import React from "react"
import Select from "react-select"

import { Col, Row, Form } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "../shared/formLabel"

function FormDropdownMulti(props) {
  // console.log(props)

  const {
    textDesc,
    form,
    field,
    dropdownItem,
    // formIsValid,
    clickedNext,
    // extraFieldValue,
    // affectedField,
  } = props

  const errorsMsg = getIn(form.errors, field.name)

  const inputErrorMessage = (touched, errors, inputName) => {
    return (clickedNext && errors[inputName]) ||
      (errors[inputName] && touched[inputName]) ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const customStyles = {
    // option: (provided, state) => ({
    //   ...provided,
    //   borderBottom: "1px dotted pink",
    //   color: state.isSelected ? "red" : "blue",
    //   padding: 20,
    // }),
    valueContainer: styles => ({
      ...styles,
      minHeight: "50px",
    }),
    // menu: () => ({
    //   //   top: "0px",
    //   zIndex: 999,
    // }),
    menu: styles => ({ ...styles, zIndex: 999 }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      width: "100%",
      minHeight: "50px",
      borderRadius: "8px",
      border: "solid 1px #E1E1E1",
      //   float: "right",
      fontStyle: "normal",
      fontStretch: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
      color: "#86a8ae",
      paddingLeft: "15px",
      paddingRight: "15px",
      backgroundColor: "#ffffff",
    }),
    // indicatorsContainer: () => ({
    //   display: "none",
    // }),
    // singleValue: (provided, state) => {
    //   const opacity = state.isDisabled ? 0.5 : 1
    //   const transition = "opacity 300ms"

    //   return { ...provided, opacity, transition }
    // },
  }

  const handleChange = value => {
    let dropdownItemCopy = Object.assign([], dropdownItem)

    dropdownItemCopy.forEach(function(part, index, theArray) {
      theArray[index].isDisabled = false
    })
    value = value ? value : [] //If value is null set an empty array

    value.forEach(function(part, inputValueIndex, inputValueArray) {
      if (inputValueArray[inputValueIndex].conflictId) {
        dropdownItemCopy.forEach(function(
          part,
          dropdownItemCopyIndex,
          dropdownItemCopyArray
        ) {
          if (
            inputValueArray[inputValueIndex].conflictId ===
            dropdownItemCopyArray[dropdownItemCopyIndex].conflictId
          ) {
            dropdownItemCopyArray[dropdownItemCopyIndex].isDisabled = true
          }
        })
      }
    })

    if (value) {
      form.setFieldValue(field.name, value)
    } else {
      form.setFieldValue(field.name, "")
    }
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Select
            // className="inputbox"
            closeMenuOnSelect={false}
            // components={animatedComponents}
            components={{
              DropdownIndicator: () => null,
              IndicatorsContainer: () => null,
              IndicatorSeparator: () => null,
            }}
            // defaultValue={[colourOptions[4], colourOptions[5]]}
            isMulti
            options={dropdownItem}
            styles={customStyles}
            onChange={value => {
              handleChange(value)
            }}
          />
          {/* {errors && touched && <span className="InputError">{errors}</span>} */}
          {/* <span className="InputError">{errors}</span> */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default FormDropdownMulti
